
export default {
    name: 'TrustPilotReviewsCollapsible',
    components: {
        TrustPilotReviews: () => import(/* webpackChunkName: "Accordion" */ "~/components/ui/TrustPilotReviews"),
        Accordion: () => import(/* webpackChunkName: "AccordionSingle" */ '~/components/ui/AccordionSingle')
    },
    props: {
        reviews: {
            default: () => ([]),
            required: true
        },
        openedInitially: {
            type: Boolean,
            default: true
        }
    },
}
